import { Product } from './types';

export const CATEGORIES = ['Men', 'Women', 'Kids', 'Sports', 'Formal', 'Casual'];

export const INITIAL_BANNERS = [
  { id: '1', imageUrl: 'https://images.unsplash.com/photo-1556906781-9a412961d289?auto=format&fit=crop&q=80&w=2000', title: 'New Sneakers Arrival' },
  { id: '2', imageUrl: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&q=80&w=2000', title: 'Sports Collection' },
];

export const MOCK_PRODUCTS: Product[] = [
  {
    id: '1',
    name: 'Nike Air Zoom Pegasus',
    description: 'The workhorse with wings. Perfect for daily runs and casual wear.',
    price: 15000,
    discountPrice: 12500,
    category: 'Sports',
    images: [
      'https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&q=80&w=600',
      'https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?auto=format&fit=crop&q=80&w=600',
      'https://images.unsplash.com/photo-1605348532760-6753d2c43329?auto=format&fit=crop&q=80&w=600'
    ],
    sizes: ['40', '41', '42', '43', '44'],
    colors: ['Red', 'Black', 'White'],
    stock: 50,
    isActive: true,
  },
  {
    id: '2',
    name: 'Classic Leather Loafers',
    description: 'Elegant formal shoes made from genuine leather.',
    price: 8500,
    category: 'Formal',
    images: [
      'https://images.unsplash.com/photo-1614252369475-531eba835eb1?auto=format&fit=crop&q=80&w=600',
      'https://images.unsplash.com/photo-1533867617858-e7b97e060509?auto=format&fit=crop&q=80&w=600',
       'https://images.unsplash.com/photo-1550346377-6e42b826f50b?auto=format&fit=crop&q=80&w=600'
    ],
    sizes: ['39', '40', '41', '42'],
    colors: ['Brown', 'Black'],
    stock: 20,
    isActive: true,
  },
  {
    id: '3',
    name: 'Adidas Ultraboost',
    description: 'Energy return for endless comfort.',
    price: 18000,
    category: 'Sports',
    images: [
      'https://images.unsplash.com/photo-1587563871167-1ee9c731aef4?auto=format&fit=crop&q=80&w=600',
      'https://images.unsplash.com/photo-1582588678413-dbf45f4823e9?auto=format&fit=crop&q=80&w=600',
       'https://images.unsplash.com/photo-1608231387042-66d1773070a5?auto=format&fit=crop&q=80&w=600'
    ],
    sizes: ['40', '41', '42', '43', '44', '45'],
    colors: ['White', 'Black'],
    stock: 35,
    isActive: true,
  },
  {
    id: '4',
    name: 'Canvas High Tops',
    description: 'Casual street style for everyday use.',
    price: 4500,
    discountPrice: 3999,
    category: 'Casual',
    images: [
      'https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?auto=format&fit=crop&q=80&w=600',
      'https://images.unsplash.com/photo-1607522370275-f14206abe5d3?auto=format&fit=crop&q=80&w=600',
      'https://images.unsplash.com/photo-1560769629-975e13f01b3a?auto=format&fit=crop&q=80&w=600'
    ],
    sizes: ['38', '39', '40', '41'],
    colors: ['Black', 'Navy'],
    stock: 100,
    isActive: true,
  }
];